module.exports = __webpack_public_path__ + "img/20190529161954477.676b3edd.png";